import { ENV_ENDPOINT_VNF, ENV_ENDPOINT_GAE, ENV_CONFIG } from "./env0";

export const TITLE_VARIO = "Variosecure";
// VNSS
export const TITLE_VNSS = "Vario Network Security Suite";
export const VERSION = "3.0.0";

// Vario SSO
export const TITLE_SSO = "Vario SSO";
export const VERSION_SSO = "1.0.0";

export const ENDPOINT_TRANSLATE =
  "https://translation.googleapis.com/language/translate/v2";

export const URL_SUPPORT_INFORMATION =
  "https://cp.variosecure.net/cp_summary/announce_message.html";

export const URL_SUPPORT_RELEASE_NOTE = "https://www.variosecure.net/vnss/";

export const URL_PATH_FAQ = "assets/faq/index.html";
// export const URL_PATH_FAQ_VTM = "assets/vtm/faq/index.html";

// export const URL_PATH_SUPPORT = "assets/vnss/support/index.html";
// export const URL_PATH_SUPPORT_VTM = "assets/vtm/support/index.html";

// メニューで使用する外部リンク
export const URL_EXTERNAL_SECURITY =
  "https://www.variosecure.net/work/mss/vsr/";
export const URL_EXTERNAL_DATA_ANALYZER = "https://www.variosecure.net/vsr-n";
export const URL_EXTERNAL_DATA_PROTECT =
  "https://www.variosecure.net/work/mss/vdap/";
export const URL_EXTERNAL_VNSS = "https://www.variosecure.net/vnss/";
export const URL_EXTERNAL_IG2 = "https://intraguardian.jp/";
export const URL_EXTERNAL_VUZ = "https://ultimatezero.variosecure.net/";

// マニュアル類のパス、ファイル名
export const PATH_MANUAL = "/assets/manuals/";
export const FILE_NAME_MANUAL_VNSS = "Vario-NSSご利用手引き.pdf";
export const FILE_NAME_MANUAL_INSTALLER = "Vario-NSSインストーラマニュアル.pdf";
export const FILE_NAME_MANUAL_AD_EXPORT = "ADエクスポートマニュアル.pdf";

// Vario SSO関連
// TODO リリースノートとアプリリストのURLは確定したら再設定
export const PATH_SSO_DOCUMENT = "/assets/sso/";
export const URL_SSO_RELEASE_NOTE = "https://www.variosecure.net/";
export const URL_SSO_APPLICATION_LIST = "https://www.variosecure.net/";
export const MAIL_ADDRESS_SSO_SUPPORT = "vuz-support@zerotrust-security.net";
export const DOC_CATEGORY_TEAMVIEWER = "TeamViewer";
export const URL_SSO_TEAMVIEWER =
  "https://www.teamviewer.com/ja/solutions/use-cases/quicksupport/";

// import from env0
export const ENDPOINT_VNF = ENV_ENDPOINT_VNF;

export const ENDPOINT_GAE = ENV_ENDPOINT_GAE;

export const firebaseConfig = () => {
  return ENV_CONFIG;
};
